import { useAppSelector } from '@redux/hooks';
import { getSeoData } from '@entities/Seo/module/selectors/getSeoData';
import { LinkColors, MyLink, Section } from '@app/shared';

import styles from './breadcrumb.module.scss';
import { Fragment } from 'react';

export const Breadcrumb = () => {
  const seoData = useAppSelector(getSeoData);

  return (
    <Section className={styles.Wrapper} data-testid="breadcrumbs-container">
      {seoData?.breadcrumb.map((item, index) => {
        return (
          <Fragment key={`${item.title}_${index}`}>
            {item.href ? (
              <MyLink data-testid="breadcrumb-item" reloaded color={LinkColors.Breadcrumbs} className={styles.Link} href={item.href}>
                {item.title}
              </MyLink>
            ) : (
              <div data-testid="breadcrumb-item" className={styles.Link}>
                {item.title}
              </div>
            )}
            <div className={styles.Separator}>-</div>
          </Fragment>
        );
      })}
    </Section>
  );
};
